import React from 'react'

import NotFound from '../../components/NotFound'
import ShowsPage from '../../components/Shows/ShowsPage'
import { fetchShowsData } from '../../data/server/query-transform/fetchShowsData'

export default props => {
  if (props.error || !props.pageTitle) {
    return <NotFound />
  }

  return <ShowsPage {...props} />
}

export async function getServerSideProps(context) {
  return await fetchShowsData({
    slug: context?.params?.slug,
    region: context?.req?.headers?.host?.split('.')?.[0],
    context
  })
}
